import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set page title
document.title = 'GUIA DE ESQUEJES';
// Initialize Meta Pixel
const initMetaPixel = () => {
  const PIXEL_ID = '1576521706880844'
  // Create fbq function
  ;
  (window as any).fbq = (window as any).fbq || function () {
    ;
    ((window as any).fbq.q = (window as any).fbq.q || []).push(arguments);
  };
  (window as any)._fbq = (window as any)._fbq || (window as any).fbq;
  (window as any).fbq.loaded = true;
  (window as any).fbq.version = '2.0';
  (window as any).fbq.queue = [];
  // Load the pixel script
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script)
  // Initialize pixel and track PageView
  ;
  (window as any).fbq('init', PIXEL_ID);
  (window as any).fbq('track', 'PageView');
  // Add noscript fallback
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
  noscript.appendChild(img);
  document.body.appendChild(noscript);
};
// Set meta tags for social sharing
const setMetaTags = () => {
  // Description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', 'Guía completa para hacer esquejes paso a paso. Multiplicá tus plantas con un método claro, fácil y barato desde tu casa.');
  } else {
    const meta = document.createElement('meta');
    meta.name = 'description';
    meta.content = 'Guía completa para hacer esquejes paso a paso. Multiplicá tus plantas con un método claro, fácil y barato desde tu casa.';
    document.head.appendChild(meta);
  }
  // Open Graph tags for social sharing
  const ogTags = [{
    property: 'og:title',
    content: 'GUIA DE ESQUEJES'
  }, {
    property: 'og:description',
    content: 'Guía completa para hacer esquejes paso a paso. Multiplicá tus plantas con un método claro, fácil y barato desde tu casa.'
  }, {
    property: 'og:type',
    content: 'website'
  }, {
    property: 'og:image',
    content: 'https://cdn.magicpatterns.com/uploads/veKGvWWMpGDJWAzPky54mN/ChatGPT_Image_19_ene_2026,_03_20_12.png'
  }];
  ogTags.forEach(tag => {
    let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
    if (metaTag) {
      metaTag.setAttribute('content', tag.content);
    } else {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('property', tag.property);
      metaTag.setAttribute('content', tag.content);
      document.head.appendChild(metaTag);
    }
  });
  // Twitter Card tags
  const twitterTags = [{
    name: 'twitter:card',
    content: 'summary_large_image'
  }, {
    name: 'twitter:title',
    content: 'GUIA DE ESQUEJES'
  }, {
    name: 'twitter:description',
    content: 'Guía completa para hacer esquejes paso a paso. Multiplicá tus plantas con un método claro, fácil y barato desde tu casa.'
  }, {
    name: 'twitter:image',
    content: 'https://cdn.magicpatterns.com/uploads/veKGvWWMpGDJWAzPky54mN/ChatGPT_Image_19_ene_2026,_03_20_12.png'
  }];
  twitterTags.forEach(tag => {
    let metaTag = document.querySelector(`meta[name="${tag.name}"]`);
    if (metaTag) {
      metaTag.setAttribute('content', tag.content);
    } else {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('name', tag.name);
      metaTag.setAttribute('content', tag.content);
      document.head.appendChild(metaTag);
    }
  });
};
// Initialize everything
initMetaPixel();
setMetaTags();
render(<App data-id="element-330" />, document.getElementById('root'));